import { useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';
import { EstateWorkItem } from 'queries';

import { Button } from 'common/button';

import ActionNeededTasksReminderModal from './action-needed-tasks-reminder-modal';

const useStyles = makeStyles(() => ({
  stackedDataFirst: {
    display: 'block',
    lineHeight: '1.43',
    width: '100%',
  },
}));

type EstateWorkItemActionNeededCellProps = {
  estateWorkItem: EstateWorkItem;
  onRefreshEstateWorkItem: () => void;
};

const EstateWorkItemActionNeededCell = ({
  estateWorkItem,
  onRefreshEstateWorkItem,
}: EstateWorkItemActionNeededCellProps) => {
  const classes = useStyles();
  const [
    activeActionNeededTasksReminderEstateWorkItem,
    setActiveActionNeededTasksReminderEstateWorkItem,
  ] = useState<EstateWorkItem | null>(null);

  const renderLastActionNeededTasksReminderDate = () => {
    if (!estateWorkItem.estate?.lastActionNeededTasksReminderDate) {
      return 'N/A';
    }

    return (
      <>
        <div>
          <Typography variant="caption">
            {format(
              Date.parse(estateWorkItem.estate?.lastActionNeededTasksReminderDate),
              'LLL d y',
            )}
          </Typography>
        </div>
        <div className={classes.stackedDataFirst}>
          <Typography variant="caption">
            {format(
              Date.parse(estateWorkItem.estate?.lastActionNeededTasksReminderDate),
              'h:mm aaa',
            )}
          </Typography>
        </div>
      </>
    );
  };

  return (
    <div className={classes.stackedDataFirst}>
      {renderLastActionNeededTasksReminderDate()}
      <div className={classes.stackedDataFirst}>
        <Button
          onClick={() => {
            setActiveActionNeededTasksReminderEstateWorkItem(estateWorkItem);
          }}
          size="tiny"
        >
          send
        </Button>
      </div>
      {activeActionNeededTasksReminderEstateWorkItem && (
        <ActionNeededTasksReminderModal
          estateWorkItem={estateWorkItem}
          onClose={() => setActiveActionNeededTasksReminderEstateWorkItem(null)}
          onReminderSent={() => {
            setActiveActionNeededTasksReminderEstateWorkItem(null);
            onRefreshEstateWorkItem();
          }}
        />
      )}
    </div>
  );
};

export default EstateWorkItemActionNeededCell;
